module.exports = __webpack_public_path__ + "static/media/34-9.d4b8d997.mp3";